"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslations = exports.useTranslate = exports.LanguageProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const language_1 = __importDefault(require("./contexts/language"));
const translate_1 = __importDefault(require("./hooks/translate"));
exports.useTranslate = translate_1.default;
const fetch_1 = __importDefault(require("./utils/fetch"));
exports.getTranslations = fetch_1.default;
const methods_1 = require("./utils/methods");
const handleTranslations = async (locale, setTranslation, setError) => {
    try {
        const payload = await (0, methods_1.exponentialBackoff)(() => (0, fetch_1.default)(locale));
        setError(undefined);
        setTranslation(payload);
    }
    catch (error) {
        setError(error);
        throw error;
    }
};
const LanguageProvider = ({ children, locale, isPrivalia }) => {
    const internalLocale = (0, react_1.useMemo)(() => (0, methods_1.getInternalLocale)(locale, isPrivalia), [locale, isPrivalia]);
    const [translations, setTranslation] = (0, react_1.useState)({});
    const [error, setError] = (0, react_1.useState)();
    const i18n = (0, react_1.useCallback)((0, methods_1.i18nBase)(translations), [translations]);
    (0, react_1.useEffect)(() => {
        if (internalLocale)
            handleTranslations(internalLocale, setTranslation, setError);
    }, [internalLocale]);
    return (0, jsx_runtime_1.jsx)(language_1.default.Provider, { value: { error, i18n, translations }, children: children });
};
exports.LanguageProvider = LanguageProvider;
